/**
 * component  are based on https://www.npmjs.com/package/@angular-material-components/file-input
 */
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { Register } from '@app/utils/type-registry';
import {
  FileUploadFieldInput,
  FileUploadFieldOutput,
} from '@trackback/widgets';
import { BaseFormFieldWidgetComponent } from '../base-form-field-widget.component';
import { ParsePipe } from '@app/pipes/parse.pipe';
import { AsyncPipe } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { FileUploadComponent } from '@app/widgets/file-upload-field/file-upload.component';

@Component({
  selector: 'tb-file-upload-field',
  templateUrl: './file-upload-field.component.html',
  styleUrls: ['./file-upload-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
    MatFormFieldModule,
    ReactiveFormsModule,
    MatTooltipModule,
    AsyncPipe,
    ParsePipe,
    FileUploadComponent,
    MatIcon,
  ],
})
@Register('FileUploadField')
export class FileUploadFieldComponent
  extends BaseFormFieldWidgetComponent<
    FileUploadFieldInput,
    FileUploadFieldOutput
  >
  implements OnInit
{
  handleGetFileAction() {
    return [this._formControl.value];
  }
}
